import { useColors } from "#components/useColors";
import { Box, Button, useColorModeValue } from "@chakra-ui/react";
import React, { useRef } from "react";

const isElement = (node?: Node | null): node is Element =>
  node?.nodeType === Node.ELEMENT_NODE;

export const Erasable = ({ children }: { children: React.ReactNode }) => {
  const erasedColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const { subtitleColor } = useColors();
  const wrapperRef = useRef<HTMLDivElement>(null);

  const onErase = async () => {
    wrapperRef.current!.firstElementChild?.scrollIntoView({
      behavior: "smooth",
    });

    const elts = document.createTreeWalker(
      wrapperRef.current!,
      NodeFilter.SHOW_ELEMENT,
    );

    while (elts.nextNode()) {
      const node = elts.currentNode;
      if (!isElement(node)) {
        continue;
      }
      if (node.nodeName.toLowerCase() === "del") {
        node.classList.toggle("erased");
        await new Promise((resolve) =>
          setTimeout(resolve, 4 * node.textContent!.length),
        );
      }
    }
  };

  return (
    <Box
      ref={wrapperRef}
      sx={{
        del: {
          transition: "color 0.5s ease-out",
          textDecoration: "none !important",
        },
        "&.erased del, del.erased": {
          color: erasedColor,
        },
        "del.erased::selection": {
          background: "highlight",
          color: subtitleColor,
        },
      }}
    >
      {children}
      <Button
        onClick={() => {
          onErase();
        }}
        mb="parSpace"
        variant="outline"
        width="full"
      >
        Echo
      </Button>
    </Box>
  );
};
